import env from 'enviro';
import { getIsQAProxy } from 'pricing-pages-lib/utils/proxyUtils';
import { SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { isValidElement } from 'react';

/**
 * This is exclusively used within the merch card components.
 * It is used to display the product icon and the title of the merch card.
 *
 * @param Title - The title of the merch card. Should be a FormattedMessage component.
 * @returns A flex container with the product icon and the title of the merch card.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const MerchCardTitleContainer = ({
  Title
}) => {
  if ( /*#__PURE__*/isValidElement(Title)) {
    if (Title.type === MerchCardTitleContainer) {
      const isQA = env.isQa() || getIsQAProxy();
      if (isQA) {
        console.warn('MerchCardTitleContainer: nested element type passed');
      }
      return Title;
    }
  }
  return /*#__PURE__*/_jsx(SectionTitle, {
    children: Title
  });
};